import React from "react";

export function LeftArrowIcon({
  className,
  width = 20,
  height = 20,
}: {
  className?: string;
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4396 10.9999L5.9729 10.9999L9.27957 14.2799C9.66624 14.6799 9.66624 15.3066 9.27957 15.7066C8.8929 16.0932 8.2529 16.0932 7.86624 15.7066L2.83957 10.7066C2.46624 10.3332 2.46624 9.66658 2.83957 9.29325L7.86624 4.29325C8.2529 3.90658 8.8929 3.90658 9.27957 4.29325C9.46624 4.49325 9.5729 4.74792 9.5729 4.99992C9.5729 5.25325 9.46624 5.51992 9.27957 5.70658L5.9729 8.99992L16.4396 8.99992C16.9996 8.99992 17.4396 9.43992 17.4396 9.99992C17.4396 10.5466 16.9996 10.9999 16.4396 10.9999Z"
        className={className}
      />
    </svg>
  );
}
